(() => {
  if (window.grayishRefreshUnitPrices) {
    window.grayishRefreshUnitPrices();
    return;
  }
  function refresh() {
    document.querySelectorAll('[data-grayish-unit-price-badge]').forEach(badge => {
      const root = badge.closest('.product-details') || badge.closest('[data-product-section]');
      const input = root?.querySelector('form[action*="/cart/add"] [name="id"]');
      if (!input) return;
      let prices;
      try { prices = JSON.parse(badge.dataset.unitPrices); } catch { return; }
      const cents = prices[String(input.value)];
      const discounted = badge.querySelector('[data-grayish-after-discount]');
      if (discounted) discounted.hidden = !(badge.dataset.discountedVariants || '').includes('|' + String(input.value) + '|');
      const value = badge.querySelector('[data-grayish-unit-value]');
      badge.hidden = !Number.isFinite(cents);
      if (value && Number.isFinite(cents)) value.textContent = String(Math.floor(cents / 100));
    });
  }
  function schedule() {
    refresh();
    window.setTimeout(refresh, 0);
    window.setTimeout(refresh, 120);
    window.setTimeout(refresh, 400);
  }
  window.grayishRefreshUnitPrices = refresh;
  document.addEventListener('change', schedule);
  ['variant:change', 'product:variant-change', 'theme:variant:change', 'shopify:section:load'].forEach(event => document.addEventListener(event, schedule));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  else refresh();
})();
